import one from "../images/gym/anproperty.png";
import two from "../images/gym/antecinno.png";
import three from "../images/gym/antgec.png";
import four from "../images/gym/gec.png";
import five from "../images/gym/conference.png";

export const GymImg = [
    {
      "img": one,
    },
    {
      "img": two,
    },
    {
      "img": three,
    },
    {
      "img": four,
    },
    {
      "img": five
    }
  ]